module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "club-wrapper"
  }, [(_vm.chiefsObject) ? _c('div', [_c('draggable', {
    staticClass: "is-multiline columns chiefs",
    model: {
      value: (_vm.chiefsObject),
      callback: function($$v) {
        _vm.chiefsObject = $$v
      },
      expression: "chiefsObject"
    }
  }, _vm._l((_vm.chiefsObject), function(chief) {
    return _c('CheifItem', {
      key: chief.id,
      staticClass: "column is-one-third",
      attrs: {
        "chief": chief
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered add-document"
  }, [_c('span', {
    staticClass: "button-wrapper link",
    on: {
      "click": function($event) {
        return _vm.handleAddChief()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить сотрудника\n      ")])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e8dc6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/Departments.vue
// module id = 931
// module chunks = 0